import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import InputText from "@app/sharedComponents/TextInput/TextInput";
import { ThemedText, ThemedView } from "@app/theme";
import { useRef, useState } from "react";
import { TextInput } from "react-native";
import { CheckCircle } from '@sharedComponents/Icons'
import axios from "axios";
import { endpoints } from "@app/api/apis";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import VerificationOTP from "@app/sharedComponents/VerificationOTP/VerificationOTP";
import ROUTE from "@app/navigationApp/routes";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import handleApiErr from "@app/helper/handleApiErr";


const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const UpdatePhoneNumber = ({navigation,route}) =>{
    const dispatch = useAppDispatch()
    const {type} = route?.params
    const inputRef = useRef<TextInput>(null);
    const [mobileNumber, setMobileNumber] = useState<string>('');
    const [isMobileNumberValid, setIsMobileNumberValid] = useState<boolean>(false);
    const [hasError, setHasError] = useState<string>('');
    const [isLimitReached, setIsLimitReached] = useState<boolean>(false)
    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [isEmailValid, setIsEmailValid] = useState(false);
    const ref = useRef(null);
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState<boolean>(false);
    
    const onPhoneInput = (text: string) => {
        setIsLimitReached(false)
        let formattedText = text.replace(/[^0-9]/g, '');
        if (formattedText.length > 10) {
          formattedText = formattedText.slice(0, 10);
        }
        setMobileNumber(formattedText);
        if (formattedText.length === 10) {
          setIsMobileNumberValid(true);
        } else {
          setIsMobileNumberValid(false);
        }
    };

    const onEmailInput = (text: string) => {
      const updateText = text.trim()
      setEmail(updateText);
      if (!emailRegex.test(updateText)) {
        setIsEmailValid(false);
        setError('Enter a valid email address');
      } else {
        setIsEmailValid(true);
        setError('');
      }
    };

    const onBlur = () => {
        if(inputRef.current){
          inputRef.current?.blur()
        }
        if (mobileNumber?.length < 10 && mobileNumber?.length > 0) {
          setHasError('Enter a 10 digit mobile number');
        } else {
          setHasError('');
        }
    }

    const closeBottomSheet = () => {
      // setTimeout(()=>{setUpdateAccountAttribute(null)},1000)
      setIsBottomSheetVisible(false);
    };

    const onVerificationSuccess = (response) => {
        navigation.navigate(ROUTE.UPDATE_ACCOUNT_SUCCESS,{type,response})
    };

    

    const onContinue = () => {
      const payload = {
        borrowerAccountId: userDetails?.linkedApplications[0]?.accountId,
        requestType: type,
        requestValue : type === 'PHONE_NUMBER' ? `+91${mobileNumber}` : email,
      }
      setButtonLoader(true)
       axios.post(endpoints.updateAccOtp,payload)
       .then(res => {
           console.log('otp sent',res);
           setIsBottomSheetVisible(true)
          //  navigation.navigate('VerifyOtp',{type:type})
       })
       .catch(err => {
        console.log('otp error',err);
        if(handleApiErr(err)){
          dispatch(showErrorSheet({
            isErrorSheetVisible: true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            errorHeading: err?.data?.header,
          }))
        }
       }).finally(()=>{
        setButtonLoader(false)
       })
    }

    return(
        <>
        <PageHeaders  pageName="UpdatePhoneEmail" navigation={navigation}/>
        <ThemedView flex={1} backgroundColor="bg-surface-primary" p="lg">
            <ThemedText variant="h3s" color="text-primary" mb="4xl" >Enter new { type==='PHONE_NUMBER'? 'mobile number':'email ID'}</ThemedText>
            {
              type === 'PHONE_NUMBER' ?
              <InputText
              ref={inputRef}
              keyboardType="phone-pad"
              onChangeText={onPhoneInput}
              onBlur={onBlur}
              value={mobileNumber}
              showAnimation
              showLabel
              label="Mobile number"
              showLeftAccessory
              leftAccessory={() => {
                return (
                      <ThemedText color="text-secondary" variant="b3r" mr="xs">+91</ThemedText>
                );
              }}
              showRightAccessory={mobileNumber?.length >= 1}
              rightAccessory={() => {
                return (
                  <ThemedView flexDirection="row" alignItems="center">
                    {isMobileNumberValid ? (
                      //@ts-ignore
                      <CheckCircle
                        size={20}
                        weight="fill"
                        fill="rgb(18, 183, 106)"
                      />
                    ) : (
                      <ThemedText color="text-secondary" variant="b3r">
                          {`${mobileNumber?.length}/10`}
                      </ThemedText>
                    )}
                  </ThemedView>
                );
              }}
              hasError={hasError}
              maxLength={10}
              />:
              <InputText
              ref={ref}
              keyboardType="email-address"
              label="Email ID"
              showLabel={true}
              placeHolder={'Enter your email ID'}
              value={email}
              onChangeText={onEmailInput}
              hasError={error}
              showRightAccessory={isEmailValid}
              autoFocus={true}
              rightAccessory={() => {
                return (
                      <CheckCircle
                        size={24}
                        weight="fill"
                        fill="rgb(18, 183, 106)"
                      />
                );
              }}
              />
            }
          <ThemedText mt="xs" variant="b4r" color="text-secondary" >OTP will be sent to this new { type==='PHONE_NUMBER'? 'number':'email'} for confirmation</ThemedText>
        </ThemedView>
        <ThemedView p="lg" borderTopWidth={1} borderColor="border-secondary" backgroundColor="bg-surface-primary">
        <Button
            size='MD'
            label={'Submit'}
            handlePress={onContinue}
            type={'SOLID'}
            disabled={!(type === 'PHONE_NUMBER' ?isMobileNumberValid :isEmailValid) || isLimitReached}
            buttonLoader={buttonLoader}
            eventName='CONTINUE_BUTTON'
          />
        </ThemedView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containsTextInput
            containerStyle={{ backgroundColor: '#fefefe' }}
        >
            <VerificationOTP 
                heading={`Confirm new ${type === "EMAIL"? 'email ID' :'mobile number'}`}
                otpType={type}
                otpSentTo={type==="PHONE_NUMBER" ? mobileNumber :email}
                otpDigitCount={6}
                resendUrl={endpoints?.updateAccOtp}  
                verifyUrl={endpoints?.verifyOtpNewuserDetails}
                attributeKeyToVerify={'borrowerAccountId'}
                attributeValueToVerify={userDetails?.linkedApplications[0]?.accountId}
                onClose={closeBottomSheet}
                onVerificationSuccess={onVerificationSuccess}
                apiPayload={{
                  borrowerAccountId: userDetails?.linkedApplications[0]?.accountId,
                  requestType: type,
                  requestValue : type === 'PHONE_NUMBER' ? `+91${mobileNumber}` : email,
                }}
                />
        </BottomSheetContainer>
        </>
    )
}

export default UpdatePhoneNumber;